import './checkbox.less';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { SafeTipsy } from 'zoomforth_component_lib/tipsy.jsx';
import Tooltip from 'zoomforth_component_lib/tooltip.jsx';
import { SquareIcon, CheckSquareIcon, CheckSquarePartialIcon } from 'zoomforth_component_lib/app_modern_icons.jsx';
import { generateUuid } from 'zoomforth_zfutils/unique_identifiers.js';

export const PlainCheckbox = ({
  id,
  checked,
  className,
  disabled,
  value,
  onChange
}) => (
  <button onClick={onChange} className={classNames('zf-plain-checkbox', { disabled }, className)}>
    <input
      id={id}
      type="checkbox"
      value={value}
      disabled={disabled}
      checked={checked} 
      onChange={onChange}
    />
    { checked == "partial" ? 
        <CheckSquarePartialIcon />
      : checked ?
        <CheckSquareIcon />
      : 
        <SquareIcon />
    }
  </button>
);

const Checkbox = ({
  inputId,
  checked,
  className,
  disabled,
  disabledReason,
  label,
  labelStyle,
  tooltipStyle,
  tooltipPlacement,
  tooltipContent,
  value,
  onChange
})=> (
  <SafeTipsy
    content={disabled ? disabledReason : null}
    placement="topRight"
  >
    <label
      style={labelStyle}
      className={classNames('zf-checkbox', { disabled }, className)}
    >
      <input
        id={inputId || generateUuid()}
        type="checkbox"
        value={value}
        disabled={disabled}
        checked={checked} 
        onChange={onChange}
      />

      { checked == "partial" ? 
          <CheckSquarePartialIcon />
        : checked ?
          <CheckSquareIcon />
        : 
          <SquareIcon />
      }

      { label }

      {
        (tooltipContent && !disabled) &&
          <Tooltip 
            style={tooltipStyle} 
            placement={tooltipPlacement} 
            value={tooltipContent} 
          />
      }
    </label>
  </SafeTipsy>
);

Checkbox.defaultProps = {
  disabledReason: null,
  disabled: false,
  labelStyle: {},
  tooltipContent: null,
  tooltipPlacement: 'right',
  tooltipStyle: {}
};

Checkbox.propTypes = {
  inputId: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.string,
  tooltipContent: PropTypes.node,
  tooltipPlacement: PropTypes.string,
  tooltipStyle: PropTypes.object,
  labelStyle: PropTypes.object,
  disabledReason: PropTypes.node,
  disabled: PropTypes.bool.isRequired,
  checked: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string
  ]),
  label: PropTypes.node.isRequired,
  onChange: PropTypes.func.isRequired
};

export default Checkbox;
